var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('span',{staticClass:"header_text q-ml-lg"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.title)?_c('q-separator',{staticClass:"q-mt-md"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }